import Vue from 'vue';

import Vuex from 'vuex';

Vue.use(Vuex);

const state={
    sessionid:'',
    logininfo:'',
    faceimg:'',
    uname:'',
    waitShUserNum:0,//待审核用户数量


}
const mutations={
    sessionidFunc(state,info){
        state.sessionid = info
    },
    logininfoFunc(state,info){
        state.logininfo = info
    },
    faceimgFunc(state,info){
        state.faceimg = info
    },
    unameFunc(state,info){
        state.uname = info
    },
    waitShUserNumFunc(state,info){
        state.waitShUserNum = info
    },

}
const actions={

    saveSessionid({ commit },data){
        commit('sessionidFunc',data)
    },
    saveLogininfo({ commit },data){
        commit('logininfoFunc',data)
    },
    saveFaceimg({ commit },data){
        commit('faceimgFunc',data)
    },
    saveUname({ commit },data){
        commit('unameFunc',data)
    },
    saveWaitShUserNum({ commit },data){
        commit('waitShUserNumFunc',data)
    },

}
const getters={

}
export  default new Vuex.Store({
    state,
    mutations,
    actions,
    getters


})

